module.exports = __webpack_public_path__ + "static/t_324_717-bc6da8d4f247cd6e54943ddae29bd769.png";